import { getItem, removeItem, setItem } from '@ms/yammer-session-storage';
import type { MultiStepScenarioCollection } from '@ms/yammer-telemetry-support';

import { yammerNamespace } from './telemetryStore';

const key = `${yammerNamespace}.MultiStepScenarioPerformance`;

type RemoveMultiStepScenarioPerformanceCollection = () => void;
export const removeMultiStepScenarioPerformanceCollection: RemoveMultiStepScenarioPerformanceCollection = () => {
  removeItem(key);
};

type GetMultiStepScenarioPerformanceCollection = () => MultiStepScenarioCollection;
export const getMultiStepScenarioPerformanceCollection: GetMultiStepScenarioPerformanceCollection = () =>
  getItem<MultiStepScenarioCollection>(key) || {};

type SetMultiStepScenarioPerformanceCollection = (multiStepScenarioCollection: MultiStepScenarioCollection) => void;
export const setMultiStepScenarioPerformanceCollection: SetMultiStepScenarioPerformanceCollection = (
  multiStepScenarioCollection: MultiStepScenarioCollection
) => {
  setItem<MultiStepScenarioCollection>(key, multiStepScenarioCollection);
};
